import component from './SpreadViews.vue'
export default component
